import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const searchByAccount = async (keyword: any, pagination: any) => {
  const { current, limit } = pagination;
  const skip = current * limit - limit;

  let acc_no = "";
  let no = keyword.toString().length;

  switch (no) {
    case 1:
      acc_no = `0000${keyword}`;
      break;
    case 2:
      acc_no = `000${keyword}`;
      break;
    case 3:
      acc_no = `00${keyword}`;
      break;
    case 4:
      acc_no = `0${keyword}`;
      break;
    default:
      acc_no = `${keyword}`;
  }
  const result = await fetch(
    `${REACT_APP_ARPS_BASE_URL}/customers/search/account?keyword=${keyword}&skip=${skip}&limit=${limit}`
  );
  const customers = await result.json();
  return customers;
};

export default searchByAccount;
